import { styled } from '@mui/material/styles';

export const Title = styled('h2')(({ theme }) => ({
  color: theme.color.primary.main,
  fontSize: theme.fontSize.large,
  fontWeight: theme.fontWeight.normal,
  margin: theme.spacing(0, 0, 4),
  textTransform: 'uppercase'
}));
